import React, { createContext, useContext, useEffect } from "react";

/**
 * Theme management — LOCKED TO LIGHT (DAY) MODE.
 *
 * The dark mode UI was retired. The provider keeps the same context
 * shape so existing consumers (`useTheme`, `ThemeToggle`) keep working
 * but always report "light" and ignore any toggle attempts.
 */
const ThemeCtx = createContext({
  theme: "light",
  resolved: "light",
  setTheme: () => {},
  toggleTheme: () => {},
});

const applyLight = () => {
  const root = document.documentElement;
  root.classList.remove("dark");
  root.setAttribute("data-theme", "light");
  document.querySelector('meta[name="theme-color"]')?.setAttribute(
    "content",
    "#FCFAF6",
  );
};

export const ThemeProvider = ({ children }) => {
  useEffect(() => {
    // Clear any persisted dark/auto preference and force light mode.
    try {
      localStorage.removeItem("alg_theme");
    } catch {
      /* noop */
    }
    applyLight();
  }, []);

  return (
    <ThemeCtx.Provider
      value={{
        theme: "light",
        resolved: "light",
        setTheme: () => {},
        toggleTheme: () => {},
      }}
    >
      {children}
    </ThemeCtx.Provider>
  );
};

export const useTheme = () => useContext(ThemeCtx);
